export default __webpack_public_path__ + "static/media/gallery-image-2.f70820bc.png";